import { Line } from "vue-chartjs";
import { ChartConfig } from "@/config/chart.js";
import Chart from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import "chartjs-adapter-moment";

export default {
  extends: Line,
  props: {
    labels: {
      type: Array,
      default: () => []
    },
    data: {
      type: Object,
      default: () => {}
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      chartOptions: {
        layout: {
          padding: {
            top: 10
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        legend: { display: false },
        scales: {
          yAxes: [
            {
              gridLines: {
                display: true,
                drawBorder: false
              },
              ticks: {
                display: true,
                fontSize: ChartConfig.fontSize,
                padding: ChartConfig.padding,
                fontFamily: ChartConfig.fontFamily,
                fontColor: ChartConfig.fontColor,
                callback: function(value) {
                  if (value <= 100) {
                    return value + "%";
                  }
                  return;
                },
                beginAtZero: true,
                max: 101
              },
              display: true
            }
          ],
          xAxes: [
            {
              gridLines: {
                display: this.gridLines,
                drawBorder: false
              },
              ticks: {
                display: true,
                fontSize: ChartConfig.fontSize,
                padding: ChartConfig.padding,
                fontFamily: ChartConfig.fontFamily,
                fontColor: ChartConfig.fontColor
              },
              display: true
            }
          ]
        }
      }
    };
  },
  beforeCreate() {
    Chart.plugins.unregister(ChartDataLabels);
  },
  mounted() {
    this.$emit("loadingChartStatus", true);
    this.render();
  },
  updated() {
    this.render();
  },
  watch: {
    labels: function() {
      this.render();
      this.$emit("loadingChartStatus", false);
    },
    data: function() {
      this.render();
      this.$emit("loadingChartStatus", false);
    }
  },
  methods: {
    render() {
      this.renderChart(
        {
          labels: this.labels,
          datasets: [
            {
              label: this.$t("message.common.seo").toUpperCase(),
              borderColor: "blue",
              borderWidth: 3,
              pointBorderColor: "blue",
              pointBackgroundColor: "blue",
              pointHoverBackgroundColor: "blue",
              pointHoverBorderColor: "blue",
              pointBorderWidth: 3,
              pointHoverRadius: 3,
              pointHoverBorderWidth: 3,
              pointRadius: 3,
              fill: true,
              clip: 3,
              backgroundColor: "transparent",
              data: this.data.seo
            },
            {
              label: this.$t("message.common.performance"),
              borderColor: "red",
              borderWidth: 3,
              pointBorderColor: "red",
              pointBackgroundColor: "red",
              pointHoverBackgroundColor: "red",
              pointHoverBorderColor: "red",
              pointBorderWidth: 3,
              pointHoverRadius: 3,
              pointHoverBorderWidth: 3,
              pointRadius: 3,
              fill: true,
              clip: 3,
              backgroundColor: "transparent",
              data: this.data.performance
            },
            {
              label: this.$t("message.common.accessibility"),
              borderColor: "orange",
              borderWidth: 3,
              pointBorderColor: "orange",
              pointBackgroundColor: "orange",
              pointHoverBackgroundColor: "orange",
              pointHoverBorderColor: "orange",
              pointBorderWidth: 3,
              pointHoverRadius: 3,
              pointHoverBorderWidth: 3,
              pointRadius: 3,
              fill: true,
              clip: 3,
              backgroundColor: "transparent",
              data: this.data.accessibility
            },
            {
              label: this.$t("message.common.bestPractices"),
              borderColor: "green",
              borderWidth: 3,
              pointBorderColor: "green",
              pointBackgroundColor: "green",
              pointHoverBackgroundColor: "green",
              pointHoverBorderColor: "green",
              pointBorderWidth: 3,
              pointHoverRadius: 3,
              pointHoverBorderWidth: 3,
              pointRadius: 3,
              fill: true,
              clip: 3,
              backgroundColor: "transparent",
              data: this.data["best-practices"]
            }
          ]
        },
        this.chartOptions
      );
    }
  }
};
